import AddIcon from "@material-ui/icons/Add";
import React from "react";

import { Select } from "../../../../../../../components/Inputs/Select/Select";
import { ButtonIcon } from "../../../../../../../components/Buttons/ButtonIcon/ButtonIcon";
import styles from "../styles.module.scss";

const TemplatesHeader = ({ title, selectProps, onOpenUpdateDialog }) => (
    <>
        <b>{title}</b>

        <div className={styles.headerCommands}>
            <Select
                hideHelpText
                {...selectProps}
            />

            <ButtonIcon
                warning
                onClick={onOpenUpdateDialog}
                title={"Add template"}
            >
                <AddIcon/>
            </ButtonIcon>
        </div>
    </>
);

export default TemplatesHeader;
